import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {injectIntl} from 'react-intl';

class MyProfileSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hoveringSectionLink: false,
		};
	}
	getActiveIndicator() {
		return (
			<div className="active-indicator">
				<div className="border" />
			</div>
		);
	}
	onSectionLinkMouseEnter() {
		this.setState({hoveringSectionLink: true});
	}
	onSectionLinkMouseLeave() {
		this.setState({hoveringSectionLink: false});
	}
	navigationV2(navLinkBase, formatMessage) {
		return (
			<div className="my-profile-section-header">
				<nav className=" section-navigation old">
					<ul>
						<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-profile-header-nav-point-profile'}>
							<NavLink to={`${navLinkBase}/profile`} className="profile" activeClassName="active">
								<span title={formatMessage({id: 'common.details'})}>{formatMessage({id: 'common.details'})}</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
					</ul>
					<ul>
						<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-profile-header-nav-point-security'}>
							<NavLink to={`${navLinkBase}/security`} className="security" activeClassName="active">
								<span title={formatMessage({id: 'header.security'})}>{formatMessage({id: 'header.security'})}</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
					</ul>
					<ul>
						<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-profile-header-nav-point-notifications'}>
							<NavLink to={`${navLinkBase}/all-notifications`} className="all-notifications" activeClassName="active">
								<span title={formatMessage({id: 'header.all_notifications'})}>{formatMessage({id: 'header.all_notifications'})}</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
					</ul>
					<ul>
						<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-profile-header-nav-point-notification-settings'}>
							<NavLink to={`${navLinkBase}/notifications`} className="notifications" activeClassName="active">
								<span title={formatMessage({id: 'header.notifications'})}>{formatMessage({id: 'header.notifications'})}</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
					</ul>
					<ul>
						<li onMouseEnter={this.onSectionLinkMouseEnter.bind(this)} onMouseLeave={this.onSectionLinkMouseLeave.bind(this)} data-cy={'my-profile-header-nav-point-task-activities'}>
							<NavLink to={`${navLinkBase}/task-activities`} className="task-activities" activeClassName="active">
								<span title={formatMessage({id: 'my_profile.task_activities'})}>{formatMessage({id: 'my_profile.task_activities'})}</span>
								{this.getActiveIndicator()}
							</NavLink>
						</li>
					</ul>
				</nav>
			</div>
		);
	}
	render() {
		const {formatMessage} = this.props.intl;
		const navLinkBase = `/my-profile`;
		return (
			<section className="app-main my-profile-section">
				<div className={'section-main v2'}>{this.navigationV2(navLinkBase, formatMessage)}</div>
			</section>
		);
	}
}

export default injectIntl(MyProfileSection);
